import { useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import api, { formatApiErrorDetail } from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "./ui/dialog";

const EMPTY = { current: "", next: "", confirm: "" };

export function ChangePasswordDialog({ open, onOpenChange }) {
  const [form, setForm] = useState(EMPTY);
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  const close = (o) => { if (!o) { setForm(EMPTY); setError(""); } onOpenChange(o); };
  const field = (key, label, testid, autoComplete) => (
    <div className="space-y-1.5">
      <Label htmlFor={testid}>{label}</Label>
      <Input id={testid} type="password" autoComplete={autoComplete} value={form[key]} data-testid={testid}
        onChange={(e) => setForm({ ...form, [key]: e.target.value })} />
    </div>
  );

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (form.next.length < 8) return setError("La nuova password deve avere almeno 8 caratteri.");
    if (form.next !== form.confirm) return setError("Le due nuove password non coincidono.");
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: form.current, new_password: form.next });
      toast.success("Password aggiornata con successo");
      close(false);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={close}>
      <DialogContent data-testid="change-password-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading">Cambia password</DialogTitle>
          <DialogDescription>Inserisci la password attuale e scegli una nuova password (almeno 8 caratteri).</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          {field("current", "Password attuale", "current-password-input", "current-password")}
          {field("next", "Nuova password", "new-password-input", "new-password")}
          {field("confirm", "Conferma nuova password", "confirm-password-input", "new-password")}
          {error && <p className="text-sm text-red-600" data-testid="change-password-error">{error}</p>}
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => close(false)} data-testid="change-password-cancel">Annulla</Button>
            <Button type="submit" disabled={saving} className="bg-blue-700 hover:bg-blue-800" data-testid="change-password-submit">
              {saving && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Salva password
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
